import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import 'rxjs/add/operator/catch';
import '../shared/adal.service';
import { config } from '../../config';
@Injectable()

export class ProductService {
    constructor(private httpClient: HttpClient) {}   

    baseUrl = config.apiUrl;
  
    getProduct(): Observable<any> {
        return this.httpClient.get(this.baseUrl + 'ReleaseManagement/getProductsList', { headers: this.getHeaders() })
            .map(response => {
                return response;
            })          
    }

    getReleaseProductsList(): Observable<any> {
        return this.httpClient.get(this.baseUrl + 'ReleaseManagement/v2/getReleaseProductsList', { headers: this.getHeaders() })
            .map(response => {
                return response;
            })           
    }  

    // Add Product
    addProduct(ApplicationData: any): Observable<any> {
        return this.httpClient.post(this.baseUrl + 'ReleaseManagement/addProductList', ApplicationData, { headers: this.getHeaders() })
            .map((response: Response) => {
                return response;
            })           
    }

    // Update Product
    updateProduct(ApplicationData: any): Observable<any> {
        return this.httpClient.post(this.baseUrl + 'ReleaseManagement/updateProductList', ApplicationData, { headers: this.getHeaders() })
            .map((response: Response) => {
                return response;
            })           
    }

    //get first displayed product
    GetFirstDisplayedOTAProduct():Observable<any>{
        return this.httpClient.get(this.baseUrl+'ReleaseManagement/v2/GetFirstDisplayedOTAProduct',{headers:this.getHeaders()}).map((response)=>{
            return response;
        })
    }
    private notify = new Subject<any>();
    notifyObservable$ = this.notify.asObservable();
    public notifyOther(data: any) {
        if (data) {
            this.notify.next(data);
        }
    }

    getHeaders(): HttpHeaders {
        let headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json');
        return headers;
    }   
}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/services/ProductService.ts